'use strict';

const Parser = require('./parser');
const Serializer = require('./serializer');

// Shorthands
exports.parse = function parse(html, options) {
  const parser = new Parser(options);
  return parser.parse(html);
};
exports.parseFragment = function parseFragment(fragmentContext, html, options) {
  if (typeof fragmentContext === 'string') {
    options = html;
    html = fragmentContext;
    fragmentContext = null;
  }
  const parser = new Parser(options);
  return parser.parseFragment(html, fragmentContext);
};
exports.serialize = function (node, options) {
  const serializer = new Serializer(node, options);
  return serializer.serialize();
};